// This function closes all <details> that are NOT in the same "family" 
// as the 'exceptDetails' argument. The same "family" means:
// - the 'exceptDetails' itself
// - its ancestors
// - its descendants
function closeUnrelatedDetails(exceptDetails) {
  const allOpenDetails = document.querySelectorAll("details[open]");
  allOpenDetails.forEach((details) => {
    // If `details` is the same as exceptDetails,
    // or it's an ancestor/descendant of exceptDetails, leave it alone
    if (
      details === exceptDetails ||
      details.contains(exceptDetails) ||
      exceptDetails.contains(details)
    ) {
      return;
    }

    // Otherwise, close it
    details.removeAttribute("open");
    // Remove active class from the corresponding summary
    const summaryToDeactivate = details.querySelector(
      "summary[data-nav-toggle-desktop]"
    );
    if (summaryToDeactivate) {
      summaryToDeactivate.classList.remove("menu-drawer__menu-item--active");
    }
  });
}

// Event listener for all click events using event delegation
document.addEventListener("click", function (e) {
  // Check if the clicked element is a <summary> or inside a <summary> with the data attribute
  const summary = e.target.closest("summary[data-nav-toggle-desktop]");

  if (summary) {
    // Prevent the default native toggle behavior
    e.preventDefault();

    // Find the parent <details> element of the clicked <summary>
    const clickedDetails = summary.parentElement;

    // Close all unrelated <details> elements (i.e. "accordion" behavior)
    closeUnrelatedDetails(clickedDetails);

    // Now toggle the clicked <details> itself
    if (clickedDetails.hasAttribute("open")) {
      // If it's currently open, close it
      clickedDetails.removeAttribute("open");
      summary.classList.remove("menu-drawer__menu-item--active");
    } else {
      // Otherwise open it
      clickedDetails.setAttribute("open", "");
      summary.classList.add("menu-drawer__menu-item--active");
    }
  } else {
    // If the click is not on a <summary>, check if it's inside any <details>
    const clickedInsideDetails = e.target.closest("details");

    if (!clickedInsideDetails) {
      // Clicked completely outside all <details>, so close everything
      document.querySelectorAll("details[open]").forEach((details) => {
        details.removeAttribute("open");
        // Remove active class from each summary
        const summaryToDeactivate = details.querySelector(
          "summary[data-nav-toggle-desktop]"
        );
        if (summaryToDeactivate) {
          summaryToDeactivate.classList.remove("menu-drawer__menu-item--active");
        }
      });
    }
  }
});

// Optional: Close all <details> when the Escape key is pressed
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    document.querySelectorAll("details[open]").forEach((details) => {
      details.removeAttribute("open");
      // Remove active class from each summary
      const summaryToDeactivate = details.querySelector(
        "summary[data-nav-toggle-desktop]"
      );
      if (summaryToDeactivate) {
        summaryToDeactivate.classList.remove("menu-drawer__menu-item--active");
      }
    });
  }
});
